<template>
  <span class="scaling-svg-container">
    <svg
      id="Icon_Person_User_People_-_Remove"
      data-name="Icon/Person User People - Remove"
      xmlns="http://www.w3.org/2000/svg"
      width="14.376"
      height="13.619"
      viewBox="0 0 14.376 13.619"
      class="scaling-svg"
    >
      <path
        id="Icon_Icon_Person-remove"
        data-name="Icon/Icon/Person-remove"
        d="M9.836,13.619a.757.757,0,0,1-.757-.756,3.783,3.783,0,1,0-7.566,0,.756.756,0,0,1-1.513,0,5.3,5.3,0,0,1,10.593,0A.757.757,0,0,1,9.836,13.619ZM5.3,6.053A3.027,3.027,0,1,1,8.323,3.027,3.03,3.03,0,0,1,5.3,6.053Zm0-4.54A1.513,1.513,0,1,0,6.809,3.027,1.516,1.516,0,0,0,5.3,1.513Zm8.322,2.27H10.593a.756.756,0,1,1,0-1.513h3.026a.756.756,0,1,1,0,1.513Z"
        transform="translate(0 0)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class RemoveUserIcon extends Vue {}
</script>

<style>
</style>
